// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/grip-vertical.js';

import { paths } from '../generated/grip-vertical';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('grip-vertical', Original, paths);
